import React from 'react';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import ScreenContext from '../../ScreenContext';
import NavActions from 'src/actions/NavActions';
import Events from 'src/logging/Events';
import Styles from '../../Styles';
import BaseAccountSetupScreen from '../BaseAccountSetupScreen';
import GmaApi from 'src/api/GmaApi';
import Settings from 'src/Settings';
import {StyleSheet, View, ScrollView} from 'react-native';
import {alertError} from '../../helpers/AlertHelper';
import AVTextInput from '../../elements/AVTextInput';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import AppRoutes from 'src/AppRoutes';
import Localized from 'src/constants/AppStrings';
import AccountApi from 'src/api/AccountApi';
type KioskChangeEmailProps = {
  data: {
    id: string;
    email: string;
  };
};
type KioskChangeEmailState = {
  newEmail: string;
  confirmEmail: string;
  error: string;
};

class KioskChangeEmail extends React.Component<
  KioskChangeEmailProps,
  KioskChangeEmailState
> {
  static contextType = ScreenContext;

  constructor(props: KioskChangeEmailProps) {
    super(props);
    this.state = {
      confirmEmail: '',
      newEmail: '',
      error: '',
    };
    this.validate = this.validate.bind(this);
    this.saveClick = this.saveClick.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
  }

  saveClick() {
    if (!this.validate()) {
      alertError(Localized.Errors.emails_do_not_match);
    } else {
      this.changeEmail();
    }
  }

  handleBack() {
    NavActions.pop();
  }

  validate() {
    return (
      this.state.newEmail &&
      this.state.confirmEmail &&
      this.state.newEmail === this.state.confirmEmail
    );
  }

  async changeEmail() {
    this.context.actions.showSpinner();

    try {
      await AccountApi.changeEmail(
        this.props.data.id,
        this.state.newEmail,
        Settings.buildType,
      );

      NavActions.replace(AppRoutes.CheckEmail);
    } catch (error) {
      if (error.message.includes('Email already exists')) {
        this.setState({
          error: Localized.Errors.email_already_exists,
        });
      } else {
        this.setState({
          error: Localized.Errors.unable_to_change_email,
        });
      }

      Events.Error.trackEvent(
        'Exception',
        'KioskChangeEmailScreen:ChangeEmail',
        error.message ? error.message : error.toString(),
      );
    } finally {
      this.context.actions.hideSpinner();
    }
  }

  render() {
    return (
      <BaseAccountSetupScreen
        headlineText={Localized.Labels.setup_app}
        instructionText={
          Localized.Labels.enter_email_associated_with_this_account
        }
      >
        <ScrollView
          style={styles.content}
          keyboardDismissMode="interactive"
          automaticallyAdjustContentInsets={false}
          keyboardShouldPersistTaps="handled"
        >
          <View style={styles.tableView}>
            <AVTextInput
              label={Localized.Labels.new_email}
              title={this.state.error}
              accessibilityLabel="Email"
              onChangeText={(text) =>
                this.setState({
                  newEmail: text,
                })
              }
              value={this.state.newEmail}
              autoCapitalize="none"
              keyboardType="email-address"
            />
            <AVTextInput
              label={Localized.Labels.confirm_new_email}
              accessibilityLabel="Confirm Email"
              onChangeText={(text) =>
                this.setState({
                  confirmEmail: text,
                })
              }
              value={this.state.confirmEmail}
              autoCapitalize="none"
              keyboardType="email-address"
            />
          </View>
        </ScrollView>
        <RoundedButton
          buttonType={ButtonType.action}
          accessibilityLabel="Save"
          onPress={this.saveClick}
          text={Localized.Buttons.save}
        />
      </BaseAccountSetupScreen>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    marginVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m2,
  },
  tableView: {
    marginBottom: Styles.Spacing.m5,
  },
});
export default withForwardedNavigationParams<KioskChangeEmailProps>()(
  KioskChangeEmail,
);
